import { Action } from 'redux-actions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getFileSparePartRequestLinesRequest } from '../../../api/SparePart/getFileSparePartRequestLinesQuery';

import { GetSparePartRequestLinesByFileId } from './actionCreators';
import * as types from './actionTypes';

function* getSparePartRequestLinesByFileIdWorker({
  payload,
}: {
  payload: GetSparePartRequestLinesByFileId;
}): Generator {
  const { fileId } = payload;

  yield executeSagaRequest(
    types.GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID,
    getFileSparePartRequestLinesRequest({ fileId }),
    { indexer: fileId },
  );

  yield put(
    types.GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID.end({
      fileId,
    }),
  );
}
function* getSparePartRequestLinesByFileIdWatcher() {
  yield takeEvery<Action<GetSparePartRequestLinesByFileId>>(
    types.GET_SPARE_PART_REQUEST_LINES_BY_FILE_ID.BASE,
    getSparePartRequestLinesByFileIdWorker,
  );
}

export default function* sparePartRequestLineSaga(): Generator {
  try {
    yield all([getSparePartRequestLinesByFileIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
